<div class="table-view-component component-table" *ngIf="model">
  <div class="table-overflow-scroll" [ngClass]="model.tableClass">
    <div
      class="table-overflow-scroll-inner {{
        disableHoverAction
          ? 'table-edit-' + getActionCounter(model.tableActions)
          : ''
      }}"
      [ngClass]="editColumClass"
    >
      <rr-overlay-spinner [spinnerStatus]="spinnerStatus"></rr-overlay-spinner>

      <table class="table table-hover mb-5" *ngIf="!model.hideTable">
        <thead class="thead-light">
          <tr>
            <th
              *ngIf="model.showSelectColumn"
              scope="col"
              class="type-checkbox"
            >
              <div
                class="table-headline-container d-flex align-items-center"
                tooltip="Select"
                placement="bottom"
              >
                <button
                  type="button"
                  class="btn-checkbox {{ isBatchSelectAllChecked() }}"
                  (click)="batchSelectAll()"
                >
                  &nbsp;
                </button>
              </div>
            </th>
            <th *ngIf="model.showRadioColumn" scope="col" class="type-checkbox">
              <div
                class="table-headline-container d-flex align-items-center"
                tooltip="Select"
                placement="bottom"
              >
                <div class="table-headline-name col icon-header">
                  <span class="oi oi-circle-check"></span>
                </div>
              </div>
            </th>

            <ng-container
              *ngFor="let fieldModel of model.fieldsToShow; let i = index"
            >
              <th
                *ngIf="showColumn(fieldModel.settings)"
                scope="col"
                class="type-{{ fieldModel.type }}"
                [ngClass]="
                  fieldModel.settings.headerClass
                    ? fieldModel.settings.headerClass
                    : ''
                "
              >
                <div
                  class="table-headline-container d-flex align-items-center"
                  tooltip="{{ fieldModel.settings.title }}"
                  placement="bottom"
                >
                  <div class="table-headline-name col">
                    {{ fieldModel.settings.title }}
                  </div>
                  <div
                    *ngIf="
                      model.results &&
                      model.results.length &&
                      fieldModel.settings.sortable
                    "
                    class="table-headline-sort col"
                  >
                    <button
                      (click)="onSortBy(fieldModel.settings.fieldName, false)"
                      class="btn-clear-style"
                    >
                      <span
                        class="oi oi-caret-top"
                        [ngClass]="
                          checkSort(fieldModel.settings.fieldName, false)
                            ? 'selected'
                            : ''
                        "
                      ></span>
                    </button>

                    <button
                      (click)="onSortBy(fieldModel.settings.fieldName, true)"
                      class="btn-clear-style"
                    >
                      <span
                        class="oi oi-caret-bottom"
                        [ngClass]="
                          checkSort(fieldModel.settings.fieldName, true)
                            ? 'selected'
                            : ''
                        "
                      ></span>
                    </button>
                  </div>
                </div>
              </th>
            </ng-container>
            <th
              *ngIf="model.tableActions && model.tableActions.length"
              class="edit-column text-center"
            >
              <button
                *ngIf="tableHasRefreshAction()"
                (click)="onRefreshClicked()"
                class="btn-clear-style"
              >
                <span class="oi oi-reload"></span>
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let tableRow of model.results; let i = index">
            <tr *ngIf="!hideRow(i)" #tableRowElement>
              <td *ngIf="model.showSelectColumn" class="type-checkbox">
                <button
                  type="button"
                  class="btn-checkbox {{
                    checkBatchItemChecked(tableRow) ? 'checked' : 'no-check'
                  }}"
                  (click)="batchSelectChange(tableRow)"
                >
                  &nbsp;
                </button>
              </td>
              <td *ngIf="model.showRadioColumn" class="type-radio">
                <button
                  type="button"
                  class="btn-radio {{
                    checkBatchItemRadioChecked(tableRow)
                      ? 'checked'
                      : 'no-check'
                  }} "
                  (click)="batchRadioChange(tableRow)"
                >
                  &nbsp;
                </button>
              </td>
              <ng-container
                *ngFor="let fieldModel of model.fieldsToShow; let i = index"
              >
                <td
                  *ngIf="showColumn(fieldModel.settings)"
                  class="type-{{ fieldModel.type }}"
                  [ngClass]="outputTableClass(fieldModel.settings, tableRow)"
                  rrshowTooltip
                  (click)="onRowClick(tableRow)"
                  (hover)="onHover($event, fieldModel.settings)"
                >
                  <ng-container [ngSwitch]="fieldModel.type">
                    <div
                      *ngSwitchCase="TABLE_FIELD_TYPE.GUID"
                      class="hover-button-trigger"
                      (rrCtrlClick)="onRowCtrlClick(tableRow)"
                      (rrMiddleClick)="onRowMiddleClick(tableRow)"
                    >
                      <button
                        class="tocopy btn-clear-style"
                        [rrCopyToClipboard]="
                          outputTableValue(fieldModel.settings, tableRow)
                        "
                      >
                        {{ outputTableValue(fieldModel.settings, tableRow) }}
                      </button>
                      <button type="button" class="hover-button">
                        <span class="oi oi-browser"></span><span>copy</span>
                      </button>
                    </div>
                    <div
                      *ngSwitchCase="TABLE_FIELD_TYPE.THUMBNAIL"
                      class="thumbnail-container"
                      (rrCtrlClick)="onRowCtrlClick(tableRow)"
                      (rrMiddleClick)="onRowMiddleClick(tableRow)"
                    >
                      <ng-template #thumbnailTooltip>
                        <img
                          class="big-thumbnail"
                          [src]="
                            outputTableValue(fieldModel.settings, tableRow) ||
                            RR_THUMBNAIL
                          "
                        />
                      </ng-template>
                      <img
                        class="thumbnail"
                        [src]="
                          outputTableValue(fieldModel.settings, tableRow) ||
                          RR_THUMBNAIL
                        "
                        [tooltip]="thumbnailTooltip"
                        [adaptivePosition]="false"
                        placement="right"
                      />
                    </div>
                    <div
                      *ngSwitchCase="TABLE_FIELD_TYPE.TAGS"
                      class="tags-container"
                      (rrCtrlClick)="onRowCtrlClick(tableRow)"
                      (rrMiddleClick)="onRowMiddleClick(tableRow)"
                    >
                      <ng-template #tags>
                        <rr-tags
                          [tags]="getTags(fieldModel.settings, tableRow)"
                          [maxAmount]="2"
                          [hasClickAction]="!!fieldModel.settings.tagClicked"
                          (tagClicked)="fieldModel.settings.tagClicked($event)"
                        >
                        </rr-tags>
                      </ng-template>
                      <ng-container *ngTemplateOutlet="tags"> </ng-container>
                    </div>
                    <div
                      *ngSwitchDefault
                      class="general-content-column"
                      [ngClass]="{ 'width-overflow': model.showScrollBar }"
                      (rrCtrlClick)="onRowCtrlClick(tableRow)"
                      (rrMiddleClick)="onRowMiddleClick(tableRow)"
                    >
                      <ng-template #tooltipTemplate>
                        <div
                          [innerHtml]="
                            outputTableTooltip(fieldModel.settings, tableRow)
                          "
                        ></div>
                      </ng-template>
                      <div
                        [tooltip]="tooltipTemplate"
                        [innerHtml]="
                          outputTableValue(fieldModel.settings, tableRow)
                        "
                        [tooltipEnable]="tooltipEnabled"
                        [adaptivePosition]="false"
                      ></div>
                    </div>
                  </ng-container>
                </td>
              </ng-container>
              <td
                *ngIf="model.tableActions && model.tableActions.length"
                style="text-align: right"
                [ngStyle]="getActionsSectionHeight(i)"
                class="edit-column text-center"
              >
                <div class="btn-group action-button">
                  <ng-container
                    *ngFor="
                      let action of model.tableActions;
                      trackBy: trackByType
                    "
                  >
                    <ng-container
                      *ngIf="action.settings.template && showAction(action)"
                    >
                      <ng-template
                        [ngTemplateOutlet]="action.settings.template"
                        [ngTemplateOutletContext]="{
                          $implicit: tableRow,
                          action: action
                        }"
                      ></ng-template>
                    </ng-container>
                    <span
                      *ngIf="!action.settings.template && showAction(action)"
                      (click)="onActionClicked(action, tableRow)"
                    >
                      <span
                        [ngClass]="
                          this.getActionIconClass(action) +
                          ' clickable mr-1 action-item-button'
                        "
                        [tooltip]="this.getActionTooltip(action)"
                        (rrMiddleClick)="
                          onActionMiddleClicked(action, tableRow)
                        "
                        (rrCtrlClick)="onActionMiddleClicked(action, tableRow)"
                      ></span>
                    </span>
                  </ng-container>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
      <div
        class="empty-table"
        *ngIf="!model.results || (model.results && !model.results.length)"
      >
        <p>Table is emtpy.</p>
      </div>
    </div>
  </div>
</div>
